import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  const resource = properties.resource;
  const operation = properties.operation;

  // Credential validation
  if (properties.useCredential && !properties.credentialId) {
    errors.push({ key: 'credentialId', message: 'A OneDrive OAuth2 credential is required when using OAuth2 authentication' });
  }

  // File operations
  if (resource === 'file') {
    if (['copy', 'delete', 'download', 'get', 'rename', 'share'].includes(operation) && !properties.fileId) {
      errors.push({ key: 'fileId', message: 'File ID is required for this operation' });
    }
    if (operation === 'rename' && !properties.newName) {
      errors.push({ key: 'newName', message: 'New Name is required for Rename operation' });
    }
    if (operation === 'search' && !properties.searchQuery) {
      errors.push({ key: 'searchQuery', message: 'Search Query is required for Search operation' });
    }
    if (operation === 'upload') {
      if (!properties.fileName) {
        errors.push({ key: 'fileName', message: 'File Name is required for Upload operation' });
      }
      if (!properties.contentBase64) {
        errors.push({ key: 'contentBase64', message: 'File Content (Base64) is required for Upload operation' });
      }
    }
  }

  // Folder operations
  if (resource === 'folder') {
    if (['delete', 'rename', 'share'].includes(operation) && !properties.folderId) {
      errors.push({ key: 'folderId', message: 'Folder ID is required for this operation' });
    }
    if (operation === 'create' && !properties.folderName) {
      errors.push({ key: 'folderName', message: 'Folder Name is required for Create operation' });
    }
    if (operation === 'rename' && !properties.newName) {
      errors.push({ key: 'newName', message: 'New Name is required for Rename operation' });
    }
    if (operation === 'search' && !properties.searchQuery) {
      errors.push({ key: 'searchQuery', message: 'Search Query is required for Search operation' });
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
